import { motion } from "framer-motion";
import { BookingForm } from "./BookingForm";
import { useT } from "../lib/prefs";

export const BookingSection = () => {
  const t = useT();
  return (
  <section id="booking" className="relative py-24 sm:py-32 overflow-hidden" data-testid="booking-section">
    <div className="absolute top-1/3 -right-40 w-[36rem] h-[36rem] rounded-full bg-violet-700/25 blur-[140px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="lg:sticky lg:top-28"
      >
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
          {t.bookTitleA}<span className="text-gradient">{t.bookTitleB}</span>{t.bookTitleC}
        </h2>
        <ol className="mt-10 space-y-5">
          {t.steps.map((s, i) => (
            <li key={s} className="flex items-center gap-5 border-t border-violet-500/20 pt-5">
              <span className="font-mono text-sm text-violet-300">0{i + 1}</span>
              <span className="text-lg text-white">{s}</span>
            </li>
          ))}
        </ol>
        <div className="mt-10 relative rounded-3xl overflow-hidden aspect-[3/2] border border-violet-400/20 clip-frame">
          <img src="/img/class2.webp" alt="Peserta private class Rahsia Trading" className="w-full h-full object-cover" data-testid="booking-class-photo" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0518]/80 via-transparent to-transparent" />
          <div className="on-dark absolute bottom-4 right-6 font-mono text-xs tracking-[0.25em] text-violet-100 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-pink-400 animate-pulse" /> {t.pastSession}
          </div>
        </div>
      </motion.div>
      <BookingForm />
    </div>
  </section>
  );
};
